<template>
  <div class="fill-height">
    <PreAdmissionStepper v-if="!preAdmissionSuccess"></PreAdmissionStepper>
    <PreAdmissionSuccess v-if="preAdmissionSuccess"></PreAdmissionSuccess>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import PreAdmissionStepper from '../components/PreAdmissionStepper.vue';
import PreAdmissionSuccess from '@/components/PreAdmissionSuccess.vue';
import api from '../services/api';

export default {
  name: 'PreAdmissionView',
  components: { PreAdmissionSuccess, PreAdmissionStepper },
  beforeMount() {
    //Create interface between Webview and Native application
    window['PreAdmissionView'] = {
      components: this,
      setUserInfo: (data) => {
        this.storeUserInfo(JSON.parse(data))
      },
      setFcmRegistrationToken: (token) =>
        this.fcmRegistrationTokenReceived(token),
      nativeGoBack: () => {
        const canGoBack = this.currentStep > 1;
        this.doPreviousStep();
        return canGoBack;
      }
    };
    var newLocale = this.$route.query.lang;
    if (newLocale === undefined) {
      newLocale = navigator.language.split('-')[0];
    }
    this.$i18n.locale = (!Object.keys(this.$i18n.messages).includes(newLocale) ? 'fr' : newLocale);
    api.interceptors.request.use(
      config => {
        config.headers['Accept-Language'] = this.$i18n.locale;
            return config;
        },
        error => {
            return Promise.reject(error);
        }
    );
  },
  mounted() {
    this.storeOptionsPreAdmission().catch((error) => {
      console.error(error);
    });
  },
  computed: {
    ...mapState('navigation', ['currentStep']),
    ...mapState('preAdmission', ['preAdmissionSuccess'])
  },
  methods: {
    ...mapActions('preAdmission', [
      'storeFcmRegistrationToken',
      'storeUserInfo',
      'storeOptionsPreAdmission'
    ]),
    ...mapActions('navigation', ['doPreviousStep']),
    fcmRegistrationTokenReceived(token) {
      this.storeFcmRegistrationToken(token);
    }
  }
};
</script>
<style lang="scss" scoped></style>
